<adapt-people-list></adapt-people-list>
